export enum DataTagType {
  General = 1,
  Security = 2
}

export const DataTagTypeLabels: { [key in DataTagType]: string } = {
  [DataTagType.General]: 'General',
  [DataTagType.Security]: 'Security',
}